// extracted by mini-css-extract-plugin
export var centerList = "_kv-6";
export var centerLoc = "_kv-a";
export var centerName = "_kv-9";
export var centerOptionBody = "_kv-8";
export var centerRow = "_kv-7";
export var centerStatus = "_kv-b";
export var empty = "_kv-5";
export var externalIcon = "_kv-c";
export var fieldHeader = "_kv-2";
export var fieldHelp = "_kv-4";
export var fieldLabel = "_kv-3";
export var panel = "_kv-0";
export var removeBtn = "_kv-d";
export var section = "_kv-1";